import CMSPage from "@/components/CMSPage";
import { Users } from "lucide-react";

export default function OurAgentsPage() {
  return (
    <CMSPage
      pageId="our-agents"
      defaultTitle="Meet Our Local Estate Agents"
      defaultDescription="Find experienced property experts in your area. Our local agents have in-depth knowledge of your neighborhood and are here to help you every step of the way."
      icon={Users}
    />
  );
}
